import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function OfferProperty({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
    setIsDisabled(true);

        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <h3>
              If you are moving in a section 8 tenant be aware that there will
              be an inspection, that the repairs will be costly and we MUST have
              approval from the owner for those repairs prior to approving them.
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="green-info-text">send this email to applicants </h3>
          </Col>
          <Col span={24}>
            <p>
              We have finished processing your application and would like to
              lease our property to you:{" "}
            </p>
          </Col>
          <Col span={24}>
            <p>Property Address - </p>
          </Col>
          <Col span={24}>
            <p>Rent Rate -</p>
          </Col>
          <Col span={24}>
            <p>
              Deposit - $0 if you select the SD waiver program outlined below or
              $ if you would like to pay in full prior to move in. Please let me
              know which you prefer as I prepare your lease.
            </p>
          </Col>
          <Col span={24}>
            <p>Lease Term - </p>
          </Col>
          <Col span={24}>
            <p>Number of Pets allowed (if any) $25 per pet per month -</p>
          </Col>
          <Col span={24}>
            <p>Utilities included (if any) -</p>
          </Col>
          <Col span={24}>
            <p>
              Tenant Benefit Package - $13 per month plus required renters
              insurance you can purchase through your tenant portal or you will
              be enrolled in our group policy for an approximate cost of $12 per
              month. Just go to{" "}
              <span className="onclick-text">
                http://insurance.residentforms.com/{" "}
              </span>{" "}
              to submit your proof of insurance
            </p>
          </Col>
          <Col span={24}>
            <p>
              Lease Prep fee - There is a $75 lease prep fee charged at lease
              signing this is a one time fee.
            </p>
          </Col>
          <Col span={24}>
            <p>
              Once you pay the deposit we will connect you with our utility
              activation service "Citizen Home Solutions" to set up water, gas,
              electric, internet , phone and home security service. They are
              often able to get you a discount over the rates you will find
              online!
            </p>
          </Col>
          <Col span={24}>
            <p>
              To secure the property, you will need to pay the deposit online or
              by dropping off a check or money order at our office (1800 Canyon
              Park Circle, Suite 202, Edmond, OK 73013). Our office hours are
              M-F, 10-2, or there is a secure mail slot that you can use at any
              time. Please make payable to Integrity Oklahoma and put the
              property address in the subject line. Or you can pay online, just
              let us know you intend to pay the deposit and we will set up your
              online portal.
            </p>
          </Col>
          <Col span={24}>
            <p>
              Security Deposit Waiver Program- You can move into your new home
              without paying a Security Deposit if your property is a part of
              the Security Deposit Waiver program. You will need to go on your
              portal and pay the first months rent to hold the property but will
              not need to pay a Deposit. This is a great way to save money at
              move in. There is a $50 set up fee that will be owed for the set
              up of this program. The fees for the program are based on the
              highest credit score in your household below you will see the fee
              ranges. The waiver fee is owed monthly or can be paid for the
              complete year if you choose.
            </p>
          </Col>
          <Col span={24}>
            <p>Credit Score and percentage</p>
            <ul>
              <li>
                <p>800-850 = 3% of monthly rent paid per month</p>
              </li>
              <li>
                <p>750-799 = 4% of monthly rent paid per month</p>
              </li>
              <li>
                <p>700-749 = 6% of monthly rent paid per month</p>
              </li>
              <li>
                <p>650-699 = 9% of monthly rent paid per month</p>
              </li>
              <li>
                <p>650-699 = 9% of monthly rent paid per month</p>
              </li>
              <li>
                <p>600-649 = 10% of monthly rent paid per month</p>
              </li>
            </ul>
          </Col>
          <Col span={24}>
            <p>
              You have 24 hours to pay the deposit to reserve the home or if
              enrolling in the Security Deposit Waiver program you will need to
              pay the first months rent to hold the property. We can hold the
              property up to 30 days from the date of the offer after the
              deposit is paid. Once we have your move in date, we will email you
              move in information and a link to sign the lease electronically.
              We will need 24 hours to schedule a move in.{" "}
            </p>
          </Col>
          <Col span={24}>
            <p>
              Once the deposit it paid it is not refundable and will be held
              should you decide to not move forward with the lease for any
              reason.
            </p>
          </Col>
          <Col span={24}>
            <p>
              All tenants are required to sign up for the Tenant Benefit Package
              at a cost of $13 per month and provide proof of their own renters
              insurance that names Integrity Oklahoma as Additionally Insured or
              purchase insurance through their tenant portal at move in or they
              will be automatically signed up for the an insurance policy with
              our vendor at a total cost of approx $12 per month. Just go to{" "}
              <span className="onclick-text">
                http://insurance.residentforms.com/{" "}
              </span>{" "}
              to submit your proof of insurance
            </p>
          </Col>
          <Col span={24}>
            <p>
              Below is a link to our lease template as well as the tenant
              benefit package info.
            </p>
          </Col>
          <Col span={24}>
            <h3>Sample Lease- (this is updated from time to time)</h3>
            <p className="onclick-text">
              https://docs.google.com/document/d/13aTOJKxLFC61nJH8bCI4eSIplsf2Ii0k4N0x8kPATAs/edit?usp=sharing
            </p>
          </Col>
          <Col span={24}>
            <p>
              <strong>Tenant Benefit Package- </strong>{" "}
              <span className="onclick-text">
                https://integrityokc.com/tenant-benefits-package/
              </span>{" "}
            </p>
          </Col>
          <Col span={24}>
            <p>
              <strong>Lead Based Paint info </strong>{" "}
              <span>For homes constructed prior to 1978</span>{" "}
            </p>
          </Col>
          <Col span={24}>
            <p className="onclick-text">
              https://www.epa.gov/lead/protect-your-family-lead-your-home-english
            </p>
          </Col>
          <Col span={24}>
            <p>
              Please respond indicating whether you would like to lease the
              property, and if so when you can pay the deposit and what day you
              would like to move in.
            </p>
          </Col>
          <Col span={24}>
            <p>- The Integrity Oklahoma Team</p>
          </Col>
          <Col span={24}>
            <h3>review these steps if section 8 applicant</h3>
            <p>-make sure the property accepts section 8</p>
            <p>
              -verify that you have a copy of their voucher and the inspection
              request form
            </p>
            <p>-make sure they pay at minimum 1/2 of the security deposit</p>
          </Col>
          <Col span={24}>
            <h3>
              -NO MOVE IN ALLOWED UNTIL AFTER PROPERTY HAS PASSED INSPECTION
            </h3>
            <p>-Turn documents into section 8 once 1/2 deposit is paid</p>
          </Col>
          <Col span={24}>
            <h3>make sure to enter this prior to moving to next step</h3>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default OfferProperty;
